// extracted by mini-css-extract-plugin
export var boxItems = "_ci-1";
export var boxItemsLg = "_ci-2";
export var button = "_ci-7";
export var buttonHoverless = "_ci-9";
export var buttonLg = "_ci-8";
export var filterGroupBox = "_ci-0";
export var icon = "_ci-3";
export var iconSecondary = "_ci-6";
export var iconWrapper = "_ci-4";
export var iconWrapperLg = "_ci-5";
export var truncatedLabel = "_ci-a";